export default __webpack_public_path__ + "static/hero-lowest-price-online-17b2efee7503ee1544e88090558e5820.jpg";